export const formatInvoiceTotal = (amount, currency = 'CAD') => {
  const numericAmount = Number(amount || 0);
  const currencyCode = String(currency || 'CAD').trim().toUpperCase();
  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
    }).format(Number.isFinite(numericAmount) ? numericAmount : 0);
  } catch {
    return `$${(Number.isFinite(numericAmount) ? numericAmount : 0).toFixed(2)}`;
  }
};

export const resolveInvoiceTotalAmount = (currentInvoice = {}, formData = {}) =>
  Number(currentInvoice?.amount || formData?.amount || 0) || 0;
